import { Route, Routes } from "react-router-dom"

import { CampaignDesktopLayout } from "../../layouts/CampaignDesktopLayout"

export function CampaignDesktopRouter() {

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <CampaignDesktopLayout />
                }
            />
        </Routes>
    )
}